import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const SignupLoading = () => {
  const { t } = useTranslation('auth');
  return (
    <div
      className="signup-page__form"
      role="status"
      aria-live="polite"
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}
    >
      <Loader2 className="spin" size={20} />
      <span>{t('signup.states.verifying')}</span>
    </div>
  );
};
